var Shopify = Shopify || {};
Shopify.money_format = document.querySelector('body').getAttribute('data-format');
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.format_money = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

class DetailsPopover extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.close = this.querySelector('.icon-close');
    this.overlay = document.querySelector('.product__nutritional-information-overlay-layer');
  }

  connectedCallback() {
    this.details.addEventListener('toggle', this.onToggle.bind(this), false);
    this.close.addEventListener('click', (e) => {
      e.target.closest('details').removeAttribute('open');
      this.overlay?.classList.add('hidden');
    });
    this.overlay?.addEventListener('click', (e) => {
      this.details.removeAttribute('open');
      this.overlay?.classList.add('hidden');
    });
  }

  onToggle(ev) {
    if (this.details.open) {
      const openPopovers = document.querySelectorAll('details-popover details[open]');
      openPopovers.forEach((element) => (element !== this.details ? (element.open = false) : null));
      this.overlay?.classList.remove('hidden');
    }
  }
}
customElements.define('details-popover', DetailsPopover);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change');
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.currentTarget.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function fixDateTimeZone(date) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear(),
    timezoneOffsetMinutes = d.getTimezoneOffset();

  d.setMinutes(d.getMinutes() - timezoneOffsetMinutes); // Adjust by timezone

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return new Date([year, month, day].join('-'));
}
window.theme = window.theme || {};
window.theme.yearMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
window.theme.weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
window.theme.nth = function (d) {
  if (d > 3 && d < 21) return 'th';
  switch (d % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};
window.theme.isValidDate = function (dateString) {
  // Check if the string matches the YYYY-MM-DD format
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    return false;
  }

  // Try to parse the string into a Date object
  const date = new Date(dateString);

  // If the date string results in an Invalid Date, return false
  if (Number.isNaN(date.getTime())) {
    return false;
  }

  // If all checks passed, return true
  return true;
};

function formateDateforUI(date) {
  var month = window.theme.yearMonths[date.getMonth()];
  var monthDay = `${date.getDate()}${window.theme.nth(date.getDate())}`;
  var weekDay = window.theme.weekDays[date.getDay()];
  return `${weekDay} ${monthDay} ${month} ${date.getFullYear()}`;
}

function formatPostcode(postcode) {
  var country = window.Shopify.country;

  if (country !== 'GB' && country !== 'IE') {
    console.warn('Unknown country code: ' + country + '. Defaulting to UK: 3');
  }

  var inwardCodeLength = country === 'GB' ? 3 : country === 'IE' ? 4 : 3;
  var normalizedPostcode = postcode.split(' ').join('').toUpperCase();
  var outwardCode = normalizedPostcode.slice(0, -inwardCodeLength);
  var inwardCode = normalizedPostcode.slice(-inwardCodeLength);

  return outwardCode + ' ' + inwardCode;
}

function isPostcodeInAreas(postcode, areas) {
  const postalCodeFormated = window.formatPostcode(postcode);
  const matchedPostals = areas.filter((outwardCode) => postalCodeFormated.indexOf(outwardCode) === 0);
  return matchedPostals.length > 0;
}

(function () {
  const select = document.getElementById('regions');
  if (!select) return;
  select.addEventListener('change', function () {
    const selectedOption = select.options[select.selectedIndex];
    const dataHref = selectedOption.getAttribute('data-href');
    if (dataHref) {
      window.location.href = dataHref;
    }
  });
})();

const trapFocusHandlers = {};
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

window.getCartTotalPriceMinusGiftCards = function (cart) {
  return (
    cart.total_price -
    cart.items.reduce((acc, item) => {
      if (item.gift_card) {
        acc += item.line_price;
      }
      return acc;
    }, 0)
  );
};

/** DISCOUNTS **/
class CartDiscounts extends HTMLElement {
  static instanceIndex = 0;
  static gifts = [];

  constructor() {
    super();
    this.index = CartDiscounts.instanceIndex;
    CartDiscounts.instanceIndex++;
    this.config = {
      cart: JSON.parse(document.querySelector('#cart-json').innerHTML),
      shipping: this.dataset.shipping ? JSON.parse(this.dataset.shipping) : false,
      cartPage: this.dataset.cartPage ? true : false,
    };
    this.giftsLoaded = this.config.cartPage;
    this.boundRender = this.render.bind(this);
  }

  connectedCallback() {
    this.connected();
  }

  disconnectedCallback() {
    window.removeEventListener('cart:update', this.boundRender);
  }

  async connected() {
    await this.init();
    await this.render();
    await this.addEventListeners();
    await this.ready();
  }

  async addEventListeners() {
    window.addEventListener('cart:update', this.boundRender);
  }

  async init() {
    this.money_format = document.querySelector('body').getAttribute('data-format');
  }

  toggleCartDiscounts() {
    if (this.config.cart?.items?.length && this.config.cart.items.every((item) => item.gift_card === true)) {
      this.style.display = 'none';
    } else {
      this.style.display = 'block';
    }
  }

  async render(evt = null) {
    if (evt) {
      this.config.cart = evt.detail.cart;
    }

    if (this.config.cartPage && this.giftsLoaded) {
      //prevent initial fetching on cart page
      CartDiscounts.gifts = this.dataset.gifts ? JSON.parse(this.dataset.gifts) : CartDiscounts.gifts;
      this.giftsLoaded = false;
    } else if (this.index == CartDiscounts.instanceIndex - 1 && !this.giftsLoaded) {
      //prevent fetching if not the last instance
      //empire.js.liquid does deeply clone a parent element
      //hence this custom element is also being cloned
      const staticCartHtml = new DOMParser().parseFromString(
        await fetch('/cart?section_id=static-cart').then((response) => response.text()),
        'text/html'
      );
      const newCartDiscounts = staticCartHtml.querySelector('cart-discounts');
      CartDiscounts.gifts = JSON.parse(newCartDiscounts.dataset.gifts);

      if (!this.config.cartPage) {
        this.giftsLoaded = true;
      }
    }

    this.toggleCartDiscounts();
    let prevThreshold = 0;
    let barHtml = '';
    let detailsHtml = '';
    //only show gift as an option if the right collection is in the basket
    //i.e. collections is either empty or if not empty there's an item in the basket that belongs to the collection
    CartDiscounts.gifts = CartDiscounts.gifts.filter((gift) => {
      return (
        gift.collections.length === 0 || (gift.collections.length > 0 && gift.amount_until_threshold !== gift.threshold)
      );
    });
    CartDiscounts.gifts.sort((a, b) => {
      if (a.amount_until_threshold === b.amount_until_threshold) {
        return a.threshold - b.threshold;
      }
      return a.amount_until_threshold - b.amount_until_threshold;
    });
    CartDiscounts.gifts.forEach((gift, index) => {
      const max = Math.max(1, gift.threshold - prevThreshold);
      const val = Math.max(0, gift.gift_specific_cart_amount - prevThreshold);
      const icon = gift.free_shipping ? 'shipping' : 'gift';
      let giftName = gift.message
        ? gift.message
        : gift.free_shipping
        ? 'Free Delivery'
        : `Free ${gift.variant ? gift.variant.name.split(' - Default')[0] : 'gift'}`;
      barHtml += `
        <progress max="${max}" value="${val}" data-ref="gift_${index}"></progress>
        ${this.icon(icon, gift.valid ? '' : 'progress-bar__icon--inactive')}
      `;

      detailsHtml += gift.valid
        ? `
        <li data-ref="gift_${index}">
          ${this.icon('added')}
          <p> ${giftName}!</p>
        </li>
      `
        : `
        <li data-ref="gift_${index}">
          ${this.icon('add')}
          <p>You're ${Shopify.formatMoney(gift.amount_until_threshold, this.money_format)} away from ${giftName}</p>
        </li>
      `;
      prevThreshold = gift.threshold;
    });
    this.innerHTML = `${barHtml !== '' ? `<div class="progress-bar__bar">${barHtml}</div>` : ''}${
      detailsHtml !== '' ? `<ul class="progress-bar__details">${detailsHtml}</ul>` : ''
    }`;
    this.style.setProperty('--total', prevThreshold);

    if (this.innerHTML == '') {
      this.style.display = 'none';
    }
  }

  async ready() {}

  icon(name = 'gift', className = '') {
    switch (name) {
      case 'gift':
        return `<svg ${
          className !== '' ? `class="${className}" ` : ''
        }xmlns="http://www.w3.org/2000/svg" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2" viewBox="0 0 16 15"><path fill="#fff" fill-rule="nonzero" d="m3.063 15 1.312-5.542L0 5.729l5.75-.5L8 0l2.25 5.25 5.75.479-4.375 3.729L12.938 15 8 12.063 3.063 15Z"/></svg>`;
        break;
      case 'shipping':
        return `<svg ${
          className !== '' ? `class="${className}" ` : ''
        }xmlns="http://www.w3.org/2000/svg" fill="none"><mask id="a" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g mask="url(#a)"><path fill="#fff" d="M4 13.333a1.929 1.929 0 0 1-1.417-.583A1.929 1.929 0 0 1 2 11.333H.667V4c0-.367.13-.68.391-.942.261-.26.575-.391.942-.391h9.333v2.666h2l2 2.667v3.333H14c0 .556-.194 1.028-.583 1.417a1.929 1.929 0 0 1-1.417.583 1.928 1.928 0 0 1-1.417-.583A1.929 1.929 0 0 1 10 11.333H6c0 .556-.194 1.028-.583 1.417A1.929 1.929 0 0 1 4 13.333ZM4 12a.645.645 0 0 0 .475-.192.645.645 0 0 0 .192-.475.645.645 0 0 0-.192-.475.645.645 0 0 0-.475-.191.645.645 0 0 0-.475.191.645.645 0 0 0-.192.475c0 .19.064.348.192.475A.645.645 0 0 0 4 12Zm-2-2h.533c.19-.2.406-.361.65-.483A1.8 1.8 0 0 1 4 9.333c.3 0 .572.061.817.184.244.122.46.283.65.483H10V4H2v6Zm10 2a.645.645 0 0 0 .475-.192.645.645 0 0 0 .192-.475.645.645 0 0 0-.192-.475.645.645 0 0 0-.475-.191.645.645 0 0 0-.475.191.645.645 0 0 0-.192.475c0 .19.064.348.192.475A.645.645 0 0 0 12 12Zm-.667-3.333h2.834l-1.5-2h-1.334v2Z"/></g></svg>`;
        break;
      case 'add':
        return `<svg  ${
          className !== '' ? `class="${className}" ` : ''
        }xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none"><path fill="#1D3F5D" d="M9.25 14h1.5v-3.25H14v-1.5h-3.25V6h-1.5v3.25H6v1.5h3.25V14Zm.756 4a7.81 7.81 0 0 1-3.11-.625 8.064 8.064 0 0 1-2.552-1.719 8.065 8.065 0 0 1-1.719-2.551A7.818 7.818 0 0 1 2 9.99c0-1.104.208-2.14.625-3.105a8.066 8.066 0 0 1 4.27-4.26A7.818 7.818 0 0 1 10.009 2a7.75 7.75 0 0 1 3.106.625 8.082 8.082 0 0 1 4.26 4.265A7.77 7.77 0 0 1 18 9.994a7.81 7.81 0 0 1-.625 3.11 8.063 8.063 0 0 1-1.719 2.552 8.08 8.08 0 0 1-2.546 1.719 7.77 7.77 0 0 1-3.104.625ZM10 16.5c1.806 0 3.34-.632 4.604-1.896C15.868 13.34 16.5 11.806 16.5 10s-.632-3.34-1.896-4.604C13.34 4.132 11.806 3.5 10 3.5s-3.34.632-4.604 1.896C4.132 6.66 3.5 8.194 3.5 10s.632 3.34 1.896 4.604C6.66 15.868 8.194 16.5 10 16.5Z"/></svg>`;
        break;
      case 'added':
        return `<svg  ${
          className !== '' ? `class="${className}" ` : ''
        }xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none"><mask id="a" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g mask="url(#a)"><path fill="#4FB37F" d="M8.23 14.063 4.707 10.52 5.75 9.479l2.48 2.459 6.02-6L15.292 7l-7.063 7.063Z"/></g></svg>`;
        break;
    }
  }
}
customElements.define('cart-discounts', CartDiscounts);

class ProductReviewsStars extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(`https://api.reviews.io/product/review?store=musclefood.com&sku=${this.dataset.sku}`)
        .then((response) => response.json())
        .then((result) => {
          //this.style.opacity = 1;
          // set preporty to this with --trustpilot-stars to the avgrge stars
          if (result) {
            const count = result.stats ? (result.stats.count ? result.stats.count : 0) : 0;
            const average = result.stats ? (result.stats.average ? result.stats.average : 0) : 0;
            this.style.setProperty('--reviews-stars-avarage', average),
              this.setAttribute('title', `Trustpilot ${average} stars - ${count} reviews`),
              this.querySelector('.product-reviews-stars-count') &&
                (this.querySelector('.product-reviews-stars-count').innerText = `(${count}) reviews`);
          }
        })
        .catch((error) => {
          console.log('error', error);
          //this.parentElement.classList.add('hidden');
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}
customElements.define('product-reviews-stars', ProductReviewsStars);
